module.exports = __webpack_public_path__ + "img/wabi.91431222.svg";